// extracted by mini-css-extract-plugin
module.exports = {"container":"PageLoadingIndicator_container__fCF1G"};